<template>
  <ais-range-input
v-slot="{ currentRefinement, range, refine, canRefine }"
:attribute="TYPESENSE_ATTRIBUTE.PRICE">

      <PricePickerInner
        :current-refinement="currentRefinement"
        :max-range="range"
        :can-refine="canRefine"
        @refine="refine($event)"
      />


  </ais-range-input>
</template>

<script lang="ts">

import { AisRangeInput } from 'vue-instantsearch/vue3/es';
import { TYPESENSE_ATTRIBUTE } from '~~/constants/typesense';

export default defineComponent({
  name: 'PricePicker',
  components: {

    AisRangeInput,
  },
  setup() {

    return { TYPESENSE_ATTRIBUTE };

  },
});

</script>
